import { userCanRead, userCanCreate, userCanRefurb } from '../helpers/permissions'

export default [
	{
		path: '/',
		component: () => import('@/components/layouts/LayoutMain'),
		children: [
			{
				path: '',
				name: 'Dashboard',
				component: () => import('@/components/views/ViewDashboard'),
				meta: { auth: true }
			},
			{
				path: '/new',
				name: 'ViewCreate',
				component: () => import('@/components/views/project/ViewCreate'),
				meta: { auth: true },
				beforeEnter: (to, from, next) => {
					next(userCanCreate ? true : { path: '/' })
				}
			},
			{
				path: '/project/:id?',
				name: 'ViewManage',
				component: () => import('@/components/views/project/ViewManage'),
				meta: { auth: true },
				beforeEnter: (to, from, next) => {
					next(userCanRead ? true : { path: '/' })
				}
			},
			{
				path: '/refurbishment/:id?',
				name: 'ViewRefurbish',
				component: () => import('@/components/views/project/ViewRefurbish'),
				meta: { auto: true },
				beforeEnter: (to, from, next) => {
					next(userCanRefurb ? true : { path: '/' })
				}
			}
		]
	},
	{
		path: '/welcome',
		name: 'Welcome',
		component: () => import('@/components/views/ViewWelcome')
	},
	{
		path: '/login',
		name: 'Login',
		component: () => import('@/components/views/ViewLogin')
	},
	{
		path: '*',
		name: '404',
		component: () => import('@/components/views/ViewLogin')
	}
]



// WEBPACK FOOTER //
// ./src/router/routes.js